// eslint-disable-next-line import/prefer-default-export
export enum FirstDayOfTheWeek {
  Monday = "Monday",
  Sunday = "Sunday",
}
